import { goBack, push, replace } from 'store/router/actions';
import { resetCart, resetGetCartStatus, resetSubmitCartStatus } from 'store/cart/actions';
import { useDispatch, useSelector } from 'react-redux';

import { clearVisitors } from 'store/visitors-emails/actions';
import qs from 'qs';
import { searchParams } from '../pages/date-select-page/interface';
import { selectCartId } from 'store/cart/selectors';
import { selectCurrentLocationId } from 'store/app-instance-configs/selectors';
import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { useSearchParams } from './use-search-params.hook';
import useKioskEnabled from 'store/kiosk/hooks/use-kiosk-enabled';

interface UseQuickCheckoutReturnValues {
  closeQuickCheckoutHandler: VoidFunction;
  openQuickCheckoutHandler: VoidFunction;
}

export const useQuickCheckout = (): UseQuickCheckoutReturnValues => {
  const dispatch = useDispatch();
  const queryParams = useSearchParams<searchParams>();
  const { pathname } = useLocation();
  const cartId = useSelector(selectCartId);
  const locationId = useSelector(selectCurrentLocationId);
  const isKioskMode = useKioskEnabled();

  const closeQuickCheckoutHandler = useCallback(() => {
    dispatch(resetSubmitCartStatus());
    dispatch(resetGetCartStatus());
    dispatch(resetCart());
    dispatch(clearVisitors());

    if (isKioskMode) {
      const queryString = qs.stringify(queryParams);
      dispatch(replace(`${pathname.replace(/\/quick-checkout$/, '')}?${queryString}`));
    } else {
      dispatch(goBack());
    }
  }, [dispatch, isKioskMode, queryParams, pathname]);

  const openQuickCheckoutHandler = useCallback(() => {
    dispatch(resetGetCartStatus());
    const queryString = qs.stringify({ ...queryParams, cartId, locationId });
    dispatch(push(`${pathname.replace(/\/$/, '')}/quick-checkout?${queryString}`));
  }, [dispatch, cartId, locationId, queryParams, pathname]);

  return {
    closeQuickCheckoutHandler,
    openQuickCheckoutHandler,
  };
};
